import { render, staticRenderFns } from "./Habitacao.vue?vue&type=template&id=57ae2e20&scoped=true"
import script from "./Habitacao.vue?vue&type=script&lang=js"
export * from "./Habitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae2e20",
  null
  
)

export default component.exports